import React, { useContext } from "react";
import { Navigate, useLocation } from "react-router-dom";
//import AccountContext from "../Context/AccountContext";

import { AuthContext } from "../Context/AuthContext";

const ProtectedRoute = ({ element }) => {
   //const context = useContext(AccountContext);
   //const { isAuthenticated, isSessionChecked } = context;
   const { isAuthenticated, loading } = useContext(AuthContext); // Get the authentication status from context
   const location = useLocation();

   //if (!isSessionChecked) {
   // Optionally, render a loading spinner or nothing until session check is done
   //return null;
   //}
   if (loading) {
      return null; // Or a loading spinner while loading
   }

   console.log("ISAUTHENTICATED:", isAuthenticated);
   if (!isAuthenticated) {
      return <Navigate to="/pages/signin3" state={{ from: location }} />;
   }
   return element;
};

export default ProtectedRoute;
